.tabWrapper {
  padding: 0 10px;
  margin-top: 10px;
}

.placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 45vh;
  color: darkgray;
  text-align: center;
}
